"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _core.makeStyles)({
  root: {
    fontSize: _theme.default.typography.pxToRem(10),
    lineHeight: _theme.default.typography.pxToRem(14)
  }
});
var _default = exports.default = useStyles;